<template>
  <div class='SettingRight'>
    <div class="settingPageRightTitle">收货地址</div>
    <div class="settingPageRightContent">
      <div class="settingPageRightContentTitle">新增收货地址</div>
      <div>
        <Address @addSuccess="addSuccess" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddressSetting",
  data() {
    return {};
  },
  methods: {
    addSuccess() {
      this.$alert("添加成功", {
        center: true,
        showClose: false,
      }).then(() => {});
    },
  },
};
</script>

<style scoped>
.SettingRight {
  margin-left: 40px;
  flex: 1;
}
.settingPageRightTitle {
  background-color: #f3f8fe;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #014d7f;
  padding-left: 10px;
}
.settingPageRightContentTitle {
  font-size: 14px;
  color: #f40;
  height: 40px;
  line-height: 40px;
  position: relative;
  left: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SettingPage/components/AddressSetting.vue